import { skipToken } from '@reduxjs/toolkit/query/react';
import type { Commission, CommissionId } from '@sorrem/shared';
import { useGetCommissionQuery } from '@sorrem-client/ui/store';
import { useCurrentCharacterArgs } from './use-current-character-id';

export interface CommissionState {
    commission: Commission | null;
    isLoading: boolean;
    isError: boolean;
}

/**
 * One commission's content, for a commission the current character holds:
 * served by `GET .../characters/:characterId/commissions/:commissionId`. A
 * null id fetches nothing.
 */
export function useCommission(commissionId: CommissionId | null): CommissionState {
    const args = useCurrentCharacterArgs();
    const { data, isLoading, isError } = useGetCommissionQuery(args === skipToken || commissionId === null ? skipToken : { ...args, commissionId });
    return { commission: data ?? null, isLoading, isError };
}
